var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-btn",class:{'disabled': _vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.buttonHandler()}}},[(_vm.checked)?_c('div',{staticClass:"checked"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }